module.exports = __webpack_public_path__ + "static/img/1_5.e79f977.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/1_5.png
// module id = cC6+
// module chunks = 44